const LABELS = {
  dashboard: "Dashboard",
  floats: "Floats",
  submissions: "Submissions",
  jobs: "Jobs",
  candidates: "Candidates",
  contacts: "Contacts",
  notifications: "Notifications",
  reports: "Reports",
  sola: "SOLA",
  integrations: "Integrations",
};

// Used when the path points at a single record rather than the list, so a
// back link reads "Back to Float" instead of "Back to Floats". Sections with
// no detail route (dashboard, sola, integrations) fall through to LABELS.
const SINGULAR_LABELS = {
  floats: "Float",
  submissions: "Submission",
  jobs: "Job",
  candidates: "Candidate",
  contacts: "Contact",
  notifications: "Notification",
  reports: "Report",
};

// Sub-segments that are sibling routes, not record ids — /floats/create is
// still the "Floats" section, whereas /floats/{uuid} is a single float.
const NON_DETAIL_SEGMENTS = new Set(["create", "new", "edit", "wizard-health"]);

function capitalize(segment) {
  return segment.charAt(0).toUpperCase() + segment.slice(1);
}

/**
 * Maps a path (with or without a query string) to a human-readable section
 * label, e.g. "/floats?q=foo" -> "Floats", "/floats/{uuid}" -> "Float",
 * "/team/candidates" -> "Team Candidates". Returns null for an empty/root path.
 */
export default function getPageLabel(path) {
  if (!path) return null;

  const pathname = path.split("?")[0];
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) return null;

  const isTeam = segments[0] === "team" && Boolean(segments[1]);
  const section = isTeam ? segments[1] : segments[0];
  const subSegment = isTeam ? segments[2] : segments[1];

  const isDetail = Boolean(subSegment) && !NON_DETAIL_SEGMENTS.has(subSegment);
  const label =
    (isDetail && SINGULAR_LABELS[section]) || LABELS[section] || capitalize(section);

  return isTeam ? `Team ${label}` : label;
}
